import Report from "@/components/management/components/report/Report";

const ReportRoutes = [{ path: "/reports", element: <Report /> }];

export default ReportRoutes;
